import { TOGGLE_USER_RESEARCH_CHOICE } from "./displayUserResearchChoiceReducer"

export const toggleUserResearchChoice = (value) => ({
    type: TOGGLE_USER_RESEARCH_CHOICE,
    payload: value
})

